/* Personalized Emotional Baggage tote renderer. Shared by the product page preview and HQ's
   print-file service.
   drawTote(ctx, {name}, scale)  print area 2400x1800 (the zippered canvas tote's front).
     NAME'S / EMOTIONAL BAGGAGE / & IMPORTANT DOCUMENTS
   Fonts required: "BIW Pet Name" (Abril Fatface), "BIW Pet Type" and "BIW Pet Type Bold"
   (Courier Prime). */
(function (root) {
  var NAME_FONT = '"BIW Pet Name"', TYPE_FONT = '"BIW Pet Type"', TYPE_BOLD = '"BIW Pet Type Bold"';
  var INK = '#141414';
  var W = 2400, H = 1800, CX = 1200, MAX_W = 1800;
  var NAME_MAX = 14;

  function cleanName(s) {
    return String(s || '').replace(/'/g, '’').replace(/\s+/g, ' ').trim().slice(0, NAME_MAX).toUpperCase();
  }
  // MOM -> MOM’S, JAMES -> JAMES’ (and a name already ending in ’S is left alone).
  function possessive(name) {
    if (!name) return '';
    if (/’S$/.test(name)) return name;
    return /S$/.test(name) ? name + '’' : name + '’S';
  }
  function fit(ctx, text, family, maxPx, minPx, maxW) {
    for (var s = maxPx; s >= minPx; s -= 4) { ctx.font = s + 'px ' + family; if (ctx.measureText(text).width <= maxW) return s; }
    return minPx;
  }
  function spaced(ctx, text, cx, y, sp) {
    var w = ctx.measureText(text).width + sp * Math.max(0, text.length - 1), x = cx - w / 2;
    ctx.textAlign = 'left';
    for (var i = 0; i < text.length; i++) { ctx.fillText(text[i], x, y); x += ctx.measureText(text[i]).width + sp; }
  }

  function drawTote(ctx, data, scale) {
    ctx.save();
    ctx.setTransform(scale || 1, 0, 0, scale || 1, 0, 0);
    ctx.clearRect(0, 0, W, H);
    if (data && data.background) { ctx.fillStyle = data.background; ctx.fillRect(0, 0, W, H); }
    // The block (about 200 to 1220) centred in the print area, and drawn 1.18 times to fill it.
    ctx.translate(CX, 900); ctx.scale(1.18, 1.18); ctx.translate(-CX, -710);
    ctx.fillStyle = INK;
    ctx.textBaseline = 'alphabetic';
    ctx.textAlign = 'center';
    var name = possessive(cleanName(data && data.name));
    var y = 560;
    if (name) {
      var px = fit(ctx, name, NAME_FONT, 330, 150, MAX_W);
      ctx.font = px + 'px ' + NAME_FONT;
      ctx.fillText(name, CX, y);
    }
    ctx.fillRect(CX - 900, 680, 1800, 10);
    ctx.font = '200px ' + TYPE_BOLD;
    var eb = 'EMOTIONAL BAGGAGE';
    var ebPx = fit(ctx, eb, TYPE_BOLD, 200, 120, 1900);
    ctx.font = ebPx + 'px ' + TYPE_BOLD;
    ctx.textAlign = 'center';
    ctx.fillText(eb, CX, 930);
    ctx.font = '112px ' + TYPE_FONT;
    spaced(ctx, '& IMPORTANT DOCUMENTS', CX, 1110, 6);
    ctx.fillRect(CX - 900, 1210, 1800, 10);
    ctx.restore();
  }

  root.drawTote = drawTote;
  root.toteName = function (s) { return possessive(cleanName(s)); };
  root.toteSize = { W: W, H: H };
  if (typeof module !== 'undefined' && module.exports) module.exports = { drawTote: drawTote, possessive: possessive, cleanName: cleanName, W: W, H: H, NAME_MAX: NAME_MAX };
})(typeof window !== 'undefined' ? window : globalThis);
